<script>
	export default {

		props: {
			searchRoute: String
		},

		watch: {
			term() {
				this.loadSearch();
			}
		},

		data() {
			return {
				active: false,
				term: '',
				searchResult: ''
			}
		},

		mounted() {
			this.reset();
		},

		methods: {
			reset() {
				this.term = '';
				this.searchResult = '';
			},

			loadSearch: _.debounce(function () {
				return axios.get(this.searchRoute + '?term=' + encodeURIComponent(this.term))
					.then(response => {
						this.searchResult = response.data;
					})
			}, 170),

			activate() {
				this.active = true;
			},

			deactivate() {
				this.active = false;
				this.reset();
			},
		}

	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/searchProduct.vue